import { FC } from "react";
import { Chip } from "@mui/material";
import __ from "src/utils/Translations";
import { Status } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import { IStatusChipProps } from "./StatusChip.models";

export const StatusChip: FC<IStatusChipProps> = ({ variant }) => {
  const variants = {
    [Status.ACCEPTED]: {
      labelUT: "Zaakceptowany",
      bgcolor: "green.50",
      color: "success.dark",
    },
    [Status.WAITING_FOR_APPROVAL]: {
      labelUT: "Oczekuje na akceptację",
      bgcolor: "grey.100",
      color: "grey.900",
    },
    [Status.CORRECTION_REQUIRED]: {
      labelUT: "Wymagana zmiana",
      bgcolor: "orange.50",
      color: "deepOrange.900",
    },
    [Status.CANCELLED]: {
      labelUT: "Anulowany",
      bgcolor: "red.50",
      color: "error.dark",
    },
    [Status.REJECTED]: {
      labelUT: "Odrzucony",
      bgcolor: "red.50",
      color: "error.dark",
    },
  };
  const currentVariant = variants[variant];

  return (
    <Chip
      label={__(currentVariant.labelUT)}
      sx={{
        backgroundColor: currentVariant.bgcolor,
        color: currentVariant.color,
      }}
      data-testid="absence-request-status"
    />
  );
};
